import React from 'react';
import styled from '@emotion/styled';
import { Table } from '@taleemabad/dsm/components';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

export interface ResponsiveMarksTableProps {
  questions: { label: string; marks: number }[];
}

export const ResponsiveMarksTable: React.FC<ResponsiveMarksTableProps> = ({
  questions,
}) => {
  const totalMarks = questions.reduce((sum, q) => sum + q.marks, 0);

  // Web Table
  const webRows = [
    {
      cells: [
        { content: 'Questions', className: 'header' },
        ...questions.map((q) => ({ content: q.label, className: 'header' })),
        { content: 'Total', className: 'header' },
      ],
    },
    {
      cells: [
        { content: 'Total Marks' },
        ...questions.map((q) => ({ content: q.marks })),
        { content: totalMarks },
      ],
    },
    {
      cells: [
        { content: 'Obt. Marks' },
        ...questions.map(() => ({ content: '' })),
        { content: '' },
      ],
    },
  ];

  // Mobile Table
  const mobileRows = [
    {
      cells: [
        { content: 'Questions', className: 'header' },
        { content: 'Total Marks', className: 'header' },
        { content: 'Obt. Marks', className: 'header' },
      ],
    },
    ...questions.map((q) => ({
      cells: [{ content: q.label }, { content: q.marks }, { content: '' }],
    })),
    {
      cells: [{ content: 'Total' }, { content: totalMarks }, { content: '' }],
    },
  ];

  return (
    <>
      <WebTableWrapper>
        <Table rows={webRows} />
      </WebTableWrapper>
      <MobileTableWrapper>
        <Table rows={mobileRows} />
      </MobileTableWrapper>
    </>
  );
};

const WebTableWrapper = styled.div`
  display: block;
  margin: var(--rk-spacing-xl) 0;
  ${mq(BreakpointSizes.xs)} {
    display: none;
  }
`;

const MobileTableWrapper = styled.div`
  display: none;
  margin: var(--rk-spacing-xl) 0;
  ${mq(BreakpointSizes.xs)} {
    display: block;
  }
`;
